<template>
  <div class="content c-c">
    <h2>
      <span></span>
      IZBERI NAPRAVO
    </h2>
    <div class="info">
      <p>S klikom na posamezno napravo jo dodate v aplikacijo za izračun prihrankov. Dodate lahko več enakih in/ali različnih naprav, s tem da za vsako vpišete njene lastnosti oz. način, kako jo uporabljate.</p>
    </div>
    <ul class="appliances">
      <li v-for="ap in aps" :key="ap.id">
        <a
          :style="{ backgroundPositionX: ap.x + 'px', backgroundPositionY: ap.y + 'px' }"
          @click="applianceNum(ap.num)"
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Appliances',
  props: {},
  data() {
    return {
      aps: [
        { id: 'H', x: -431, y: 0, num: 1 },
        { id: 'PS', x: -438, y: -477, num: 2 },
        { id: 'Z', x: -431, y: -95, num: 3 },
        { id: 'PX', x: -438, y: -285, num: 4 },
        { id: 'SS', x: -438, y: -380, num: 5 },
        { id: 'PGV', x: -436, y: -190, num: 6 },
        { id: 'R', x: -436, y: -577, num: 7 },
        { id: 'T', x: 13, y: -687, num: 8 },
        { id: 'TV', x: -100, y: -778, num: 9 },
        { id: 'P', x: -102, y: -979, num: 10 },
        { id: 'AC', x: -99, y: -878, num: 11 },
      ],
    };
  },
  methods: {
    applianceNum(x) {
      this.$emit('applianceClicked', x);
    },
  },
};
</script>

<style>
</style>